/**
 * Shared chrome for the full-width sticky top banners (ImpersonationBanner,
 * EnvironmentBanner). Keeps positioning, animation, spacing, and the tablet
 * media query in sync across both. Each consumer adds its own `background` and
 * `z-index` (and any banner-specific rules).
 */

import { css, keyframes } from 'styled-components';
import { media } from '../../styles/media';

export const bannerSlideDown = keyframes`
  from { transform: translateY(-100%); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
`;

/** Base layout/animation for a sticky top banner. Set `background` + `z-index` in the consumer. */
export const bannerBaseCss = css`
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
  padding: ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[6]};
  color: #ffffff;
  animation: ${bannerSlideDown} 200ms ease-out;
  min-height: 44px;

  ${media.tablet} {
    padding: ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[4]};
  }
`;

/** Leading icon inside a banner. */
export const bannerIconCss = css`
  flex-shrink: 0;
  width: 18px;
  height: 18px;
`;

/** Text label inside a banner. */
export const bannerLabelCss = css`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  line-height: ${({ theme }) => theme.typography.lineHeight.tight};
`;
